export enum TipoCadastroEnum {
  USUARIO_FORNECEDOR = 'USUARIO_FORNECEDOR',
  USUARIO_CONSUMIDOR = 'USUARIO_CONSUMIDOR',
}
